/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';

import { type EnderecoPesquisa } from './types';

type Param = {
    cidade: string,
    estado: string,
    logradouro: string,
};

const pesquisarLogradouroEnderecoEntrega = (params: Param): AxiosPromise<EnderecoPesquisa[]> => (
    xhr.get('/busca-endereco', { params })
);

export default pesquisarLogradouroEnderecoEntrega;
